import { fetchSeoByPath } from '../api/seo'
import { SEO_DEFAULT } from './defaultSeo'
import { normalizeSeoPath, routeSeoPath } from './routePath'

let requestId = 0

/**
 * Карточка новости берёт title, description и keywords у списка.
 * H1 списка на неё не переносится.
 */
function sectionSeoPath(route) {
  if (route && route.name === 'articles:id') return '/articles'
  if (route && route.name === 'actions:id') return '/actions'
  return null
}

/**
 * Запись type=default — общие meta бренда.
 * Пустые поля страницы API уже дополняет ею.
 * H1 показывается только если link совпал с текущим маршрутом.
 */
export async function applyRouteSeo(store, route) {
  const id = ++requestId
  const path = routeSeoPath(route)
  const sectionPath = sectionSeoPath(route)
  store.commit('SET_SEO_PAGE', null)

  const seo = await fetchSeoByPath(sectionPath || path)
  if (id !== requestId) return

  if (!seo) {
    store.commit('SET_SEO_PAGE', { ...SEO_DEFAULT })
    return
  }

  if (sectionPath) {
    store.commit('SET_SEO_PAGE', { ...seo, h1: '' })
    return
  }

  const matched = normalizeSeoPath(seo.link) === path
  store.commit('SET_SEO_PAGE', matched ? seo : { ...seo, h1: '' })
}
